// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-choose-business-unit-dialog .authenticate-choose-active-unit-description {
  margin-bottom: 35px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-user-shared/choose-business-unit-dialog/choose-business-unit-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR","sourcesContent":[".fi-choose-business-unit-dialog {\r\n    .authenticate-choose-active-unit-description {\r\n        margin-bottom: 35px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
